"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mongoose_1 = require("mongoose");
const enum_1 = require("./enum");
const PlanConfigurationSchema = new mongoose_1.Schema({
    tag: { type: String, required: true },
    slack_support: { type: Boolean, default: false },
    concurrent_builds: { type: Number, required: true },
    project_limit: { type: Number, required: true },
    deploy_private_organization: { type: Boolean, default: false },
    preview_comments: { type: Boolean, default: false },
    analytics: { type: Boolean, default: false },
    build_minutes: { type: Number, required: true },
    log_retention: { type: Number, required: true },
    bandwidth: { type: Number, required: true },
    price: { type: Number, required: true },
    region: { type: mongoose_1.Schema.Types.ObjectId, ref: "Region", required: false },
    plan_type: {
        type: String,
        enum: Object.values(enum_1.SUBSCRIPTION_PLAN_TYPE),
        required: true,
    },
    memory: { type: Number, required: true },
    build_timeout: { type: Number, required: true },
    storage: { type: Number, required: true },
    cpu: { type: Number, required: true },
    tokens: { type: Number, required: false },
    token_request: { type: Number, required: false },
}, { timestamps: true });
exports.default = (0, mongoose_1.model)("PlanConfigurations", PlanConfigurationSchema, "plan_configurations");
